import { render, staticRenderFns } from "./KwertyForInstitutions.vue?vue&type=template&id=5b82f174&scoped=true"
import script from "./KwertyForInstitutions.vue?vue&type=script&lang=js"
export * from "./KwertyForInstitutions.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=5b82f174&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82f174",
  null
  
)

export default component.exports